import { FacilityBagScanPage } from '@/pages/facility/workflows/bag-scan';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/bag-scan')({
	component: FacilityBagScanPage,
});
